import React from 'react'

function Community() {
  return (
    <>
      <div class="appHeader text-light" style={{ boxShadow: 'none' }}>
        <div class="pageTitle" style={{ width: '100%', right: '0' }}>
          Communities
        </div>
        <div class="right">
          <a href="#" class="headerButton">
            <ion-icon
              name="search-outline"
              role="img"
              class="md hydrated"
              aria-label="search-outline"
            ></ion-icon>
          </a>
        </div>
      </div>
      <div id="appCapsule">
        <ul class="listview image-listview">
          <li>
            <div class="item inn">
              <div class="icon-box bg-success">
                <ion-icon
                  name="people-outline"
                  role="img"
                  class="md hydrated"
                  aria-label="people-outline"
                ></ion-icon>
              </div>
              {/* <div class="icon-box ">
                <ion-icon
                  name="notifications-outline"
                  role="img"
                  class="md hydrated"
                  aria-label="notifications-outline"
                ></ion-icon>
              </div> */}
              <div class="in">
                <div>New Community</div>
              </div>
            </div>
          </li>
        </ul>
        &nbsp;
        <ul class="listview image-listview">
          <li style={{ borderBottom: '0.1px solid' }}>
            <div class="item inn">
              <div class="icon-box ">
                <ion-icon
                  name="people-outline"
                  role="img"
                  class="md hydrated"
                  aria-label="people-outline"
                ></ion-icon>
              </div>
              <div class="in">
                <div>Notifications</div>
              </div>
            </div>
          </li>
          <li>
            <div class="item inn">
              <div class="icon-box ">
                <ion-icon
                  name="notifications-outline"
                  role="img"
                  class="md hydrated"
                  aria-label="notifications-outline"
                ></ion-icon>
              </div>
              <div class="in">
                <div>Notifications</div>
              </div>
            </div>
          </li>
          <li>
            <div class="item inn">
              <div class="icon-box ">
                <ion-icon
                  name="image-outline"
                  role="img"
                  class="md hydrated"
                  aria-label="image-outline"
                ></ion-icon>
              </div>
              <div class="in">
                <div>Media visibility</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Community
